var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor send-email" }, [
    _vm.reservationPlans.length > 0
      ? _c(
          "div",
          { staticClass: "wrapper" },
          [
            _c("div", { staticClass: "title" }, [_vm._v("Select Reservation")]),
            _vm._v(" "),
            _c(
              "a-select",
              {
                attrs: { "show-search": "" },
                model: {
                  value: _vm.clone.reservationPlanId,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "reservationPlanId", $$v)
                  },
                  expression: "clone.reservationPlanId",
                },
              },
              _vm._l(_vm.reservationPlans, function (reservationPlan, index) {
                return _c(
                  "a-select-option",
                  { key: index, attrs: { value: reservationPlan._id } },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(reservationPlan.title) +
                        "\n            "
                    ),
                  ]
                )
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "a-select",
              {
                staticClass: "duration",
                attrs: { "show-search": "" },
                model: {
                  value: _vm.clone.duration,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "duration", $$v)
                  },
                  expression: "clone.duration",
                },
              },
              _vm._l(_vm.remindDates, function (remindDate, index) {
                return _c(
                  "a-select-option",
                  { key: index, attrs: { value: remindDate.value } },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(remindDate.label) +
                        "\n            "
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        )
      : _c("div", { staticClass: "empty-list" }, [
          _vm._v("Lütfen rezervasyon planı oluşturunuz."),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }